module.exports = __webpack_public_path__ + "img/zxgl.b13d5e84.svg";